// extracted by mini-css-extract-plugin
module.exports = {"faq":"SingleFAQ_faq__1ZCVn","text":"SingleFAQ_text__0eS47","open":"SingleFAQ_open__eMu9S","titleContainer":"SingleFAQ_titleContainer__y9ksf","title":"SingleFAQ_title__xC_SU"};